/* Liyora — colour-aware "Kombini Tamamla" and "Bunları da Beğenebilirsiniz".
   Follows the colour picked on the product page: each suggested product shows
   its matching (or best-going) colour photo and links straight to that variant. */
(() => {
  'use strict';
  if (window.__liyoraLook) return;
  window.__liyoraLook = true;

  const LIGHT_NEUTRALS = ['krem', 'ekru', 'bej', 'taş', 'vizon', 'camel', 'pudra', 'a.gri', 'beyaz'];
  const DARK_NEUTRALS = ['siyah', 'kahve', 'kahverengi', 'antrasit', 'füme', 'lacivert', 'laci', 'gri'];
  const norm = (s) => (s || '').toLocaleLowerCase('tr').trim();
  const toRgb = (h) => {
    const m = /^#?([0-9a-f]{6})$/i.exec((h || '').trim());
    if (!m) return null;
    const n = parseInt(m[1], 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  };
  const lightness = (c) => (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255;
  const distance = (a, b) => Math.sqrt(a.reduce((s, v, i) => s + (v - b[i]) ** 2, 0));

  function mainColor() {
    const input = document.querySelector('[data-product-zone] .option--color input:checked');
    if (!input) return null;
    return { label: input.value, name: norm(input.value), rgb: toRgb(input.dataset.color) };
  }

  function colorScore(c, main, mode) {
    const name = norm(c.n);
    if (name === main.name) return 100;
    const rgb = toRgb(c.h);
    if (mode === 'pair') {
      // A dark piece goes best with light neutrals, a light piece with dark ones.
      const dark = main.rgb ? lightness(main.rgb) < 0.4 : DARK_NEUTRALS.includes(main.name);
      const best = dark ? LIGHT_NEUTRALS : DARK_NEUTRALS;
      const next = dark ? DARK_NEUTRALS : LIGHT_NEUTRALS;
      if (best.includes(name)) return 70 - best.indexOf(name);
      if (next.includes(name)) return 50 - next.indexOf(name);
      if (rgb && main.rgb) return Math.max(0, 40 - distance(rgb, main.rgb) / 10);
      return 5;
    }
    if (rgb && main.rgb) return Math.max(0, 80 - distance(rgb, main.rgb) / 5);
    return 5;
  }

  function colorsOf(item) {
    if (!item._colors) {
      try {
        item._colors = JSON.parse(item.querySelector('[data-look-colors]').textContent) || [];
      } catch (e) {
        item._colors = [];
      }
    }
    return item._colors;
  }

  function apply(item, c) {
    if (!c) return;
    const img = item.querySelector('.card__img:not(.card__img--alt), .mini-card__media img');
    if (img && c.s && img.dataset.lookSrc !== c.s) {
      img.dataset.lookSrc = c.s;
      img.srcset = c.l ? `${c.s} 450w, ${c.l} 900w` : c.s;
      img.src = c.l || c.s;
    }
    item.classList.add('is-look-set');
    const base = item.dataset.lookUrl;
    const url = `${base}${base.includes('?') ? '&' : '?'}variant=${c.v}`;
    item.querySelectorAll('a[href]').forEach((a) => { a.href = url; });
    const label = item.querySelector('[data-look-label]');
    if (label) label.textContent = c.n;
    item.querySelectorAll('.swatch-dot').forEach((d) => d.classList.toggle('is-active', norm(d.title) === norm(c.n)));
  }

  function update(list, main) {
    const mode = list.dataset.lookMode || 'similar';
    const limit = Number(list.dataset.lookLimit) || 4;
    const items = Array.from(list.querySelectorAll('[data-look-item]'));
    const ranked = items.map((el, i) => {
      let best = null;
      let score = -1;
      if (main) {
        colorsOf(el).forEach((c) => {
          const s = colorScore(c, main, mode);
          if (s > score) { score = s; best = c; }
        });
      }
      return { el, i, best, group: el.dataset.lookGroup, score: (main ? score : 0) + (Number(el.dataset.lookBoost) || 0) };
    });
    ranked.sort((a, b) => b.score - a.score || a.i - b.i);

    // Keep the outfit varied: at most two pieces of the same kind first.
    const cap = mode === 'pair' ? 2 : Infinity;
    const chosen = [];
    const perGroup = {};
    ranked.forEach((r) => {
      if (chosen.length < limit && (perGroup[r.group] || 0) < cap) {
        chosen.push(r);
        perGroup[r.group] = (perGroup[r.group] || 0) + 1;
      }
    });
    ranked.forEach((r) => { if (chosen.length < limit && !chosen.includes(r)) chosen.push(r); });

    ranked.forEach((r) => { r.el.hidden = !chosen.includes(r); });
    chosen.forEach((r) => {
      list.appendChild(r.el);
      if (main) apply(r.el, r.best);
    });

    const box = list.closest('[data-look]');
    if (box) {
      box.hidden = chosen.length === 0;
      const hint = box.querySelector('[data-look-hint]');
      if (hint && main) hint.textContent = (hint.dataset.template || '').replace('[renk]', main.label);
    }
  }

  function run() {
    const main = mainColor();
    document.querySelectorAll('[data-look-list]').forEach((list) => update(list, main));
  }

  document.addEventListener('change', (e) => {
    if (e.target.closest && e.target.closest('[data-product-zone] .option--color')) run();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
